'use strict';

import { scrollIntoView } from 'seamless-scroll-polyfill';

import { enableScrolling, disableScrolling } from './utils';

const navBp: number = 1080;
const header: HTMLElement = document.querySelector('.js-main-header') as HTMLElement;
const mainNav = document.querySelector<HTMLElement>('.js-mobile-nav');
const toggleBtns = header?.querySelectorAll('.js-toggle-nav');
const dropdowns = mainNav?.querySelectorAll<HTMLElement>('.nav__dropdown');
const navDropdownLinks = header?.querySelectorAll('a[data-dropdown="true"]');
const backBtns = mainNav?.querySelectorAll('.js-nav-back');
const overlay = header?.querySelector('.js-nav-overlay');

let mobile = !window.matchMedia(`(min-width: ${navBp}px)`).matches;

/* --- Close the open submenus (mobile & desktop) --- */
export function closeAllSubMenus() {
  if (!mainNav) {
    return;
  }

  const links = mainNav.querySelectorAll('a.open');
  const dropdowns = mainNav.querySelectorAll<HTMLElement>('.nav__dropdown.open');

  // mobileNavMenu.classList.remove('sub-menu-open');

  links.forEach((link) => {
    link.classList.remove('open');
  });

  dropdowns.forEach((dropdown) => {
    dropdown.classList.remove('sub-menu-open');
    dropdown.classList.remove('open');
    dropdown.setAttribute('aria-hidden', 'true');
    // dropdown.style.maxHeight = '';
  });

  enableScrolling();

  overlay?.classList.remove('visible');
}

export function closeMobileNav() {
  if (!mainNav) {
    return;
  }

  mainNav.classList.remove('open');

  enableScrolling();

  // reset any sub menus that were opened
  setTimeout(function() {
    closeAllSubMenus();
  }, 600); // set the time to be the same as the css animation to close the nav
}

document.addEventListener('DOMContentLoaded', function() {
  // Hours dropdown
  const hoursDropdownToggle = header?.querySelector('.js-nav-hours-dropdown-toggle');

  hoursDropdownToggle?.addEventListener('click', (e) => {
    e.preventDefault();
    let dropdown = hoursDropdownToggle.nextElementSibling as HTMLElement;

    if (hoursDropdownToggle.classList.contains('open')) {
      hoursDropdownToggle.classList.remove('open');
      dropdown?.setAttribute('aria-hidden', 'true');
    } else {
      hoursDropdownToggle.classList.add('open');
      dropdown?.removeAttribute('aria-hidden');
    }
  });

  if (!header || !mainNav) {
    // No full nav on this page — skip nav logic entirely
    return;
  }

  sizeDropdowns();

  toggleBtns?.forEach((btn) => {
    btn.addEventListener('click', () => toggleNav(btn));
  });

  backBtns?.forEach((btn) => {
    btn.addEventListener('click', () => goBack(btn));
  });

  navDropdownLinks?.forEach((dropdownLink) => {
    // links that have dropdowns
    dropdownLink.addEventListener('click', toggleSubMenu);
  });

  overlay?.addEventListener('click', closeAllSubMenus);

  // Helper to check if any dropdown is open
  const isDropdownOpen = (): boolean => {
    return document.querySelector('.nav__dropdown--level-1.open') !== null;
  };

  function toggleNav(btn) {
    if (!mainNav) {
      return;
    }
    if (mainNav.classList.contains('open')) {
      closeMobileNav();
      btn.classList.remove('open');
    } else {
      document.dispatchEvent(new CustomEvent('nav:open'));

      if (mobile) {
        btn.classList.add('open');
        // scroll to top of nav before opening

        scrollIntoView(mainNav, { behavior: 'smooth' });

        mainNav.classList.add('open');
        disableScrolling();
      } else {
        mainNav.classList.add('open');
      }
    }
  }

  function toggleSubMenu(e: Event) {
    let navLinkTarget = e.target as HTMLElement;

    // Make sure it's got the link itself
    if (navLinkTarget.classList.contains('nav__link-text')) {
      navLinkTarget = navLinkTarget.parentElement as HTMLElement;
    }

    if (
      // If it's a level three link...
      (navLinkTarget.classList.contains('nav__link--level-3') ||
      // or it's a level 2 link that is already open...
      (navLinkTarget.classList.contains('nav__link--level-2') && navLinkTarget.classList.contains('open')))
    ) {
      // ...do nothing
      return;
    }

    e.preventDefault();

    if (!this.classList.contains('open')) {
      openSubMenu(e);
    } else {
      closeAllSubMenus();
    }
  }

  /* --- Open the submenu for the selected link (mobile & desktop) --- */
  function openSubMenu(e) {
    let link = e.target;

    if (link.tagName === 'SPAN') {
      link = link.closest('a');
    }

    closeSubMenus(link); // close all open sub menus first

    const dropdown = link.nextElementSibling;

    link.classList.add('open');

    if (!mobile && dropdown.classList.contains('nav__dropdown--level-1')) {
      // get the first child dropdown and open it
      let childDropdowns = dropdown.querySelectorAll('.nav__dropdown--level-2');

      if (childDropdowns.length) {
        childDropdowns[0].classList.add('open');
        childDropdowns[0].previousElementSibling.classList.add('open');
        dropdown.classList.add('sub-menu-open');
      }

      if (isFixed) {
        disableScrolling();
      }

      // dropdown.style.maxHeight = `${dropdown.scrollHeight}px`;
      dropdown.classList.add('open');
      document.dispatchEvent(new CustomEvent('nav:open'));
    } else {
      const parentDropdown = link.closest('.nav__dropdown');
      parentDropdown?.classList.add('sub-menu-open');
      dropdown.classList.add('open');
      dropdown.setAttribute('aria-hidden', false);
      parentDropdown?.scrollTo({
        top: 0,
      });
    }

    overlay?.classList.add('visible');
  }

  // Close submenus that are at the same level as the one being opened
  function closeSubMenus(link) {
    if (!mobile) {
      let parent = link.closest('.nav__list');

      let activeDropdowns = parent.querySelectorAll('.nav__dropdown.open');

      let activeLinks = parent.querySelectorAll('.nav__link.open');

      activeLinks?.forEach((link) => {
        link.classList.remove('open');
      });

      activeDropdowns?.forEach((dropdown) => {
        dropdown.classList.remove('open');
        dropdown.classList.remove('sub-menu-open');
        dropdown.setAttribute('aria-hidden', 'true');
      });
    }
  }

  function goBack(btn) {
    const dropdown = btn.closest('.nav__dropdown.open');

    if (!dropdown) {
      return;
    }

    const parentDropdown = dropdown.closest('.nav__dropdown.sub-menu-open');
    let activeLink = parentDropdown?.querySelector('.open');
    activeLink?.classList.remove('open');
    dropdown.classList.remove('open');
    parentDropdown?.classList.remove('sub-menu-open');
  }

  function sizeDropdowns() {
    dropdowns?.forEach((dropdown) => {
      if (dropdown.classList.contains('nav__dropdown--level-1')) {
        if (!mobile) {
          const lists = dropdown.querySelectorAll('.nav__list--level-3');

          if (!lists) {
            return;
          }

          let height = 0;
          lists.forEach((list) => {
            if (list.scrollHeight > height) {
              height = list.scrollHeight;
            }
          });

          dropdown.style.minHeight = `${height}px`;
        } else {
          dropdown.style.minHeight = '';
        }
      }
    });
  }

  document.addEventListener('click', function(event) {
    if (!mobile && mainNav && !mainNav.contains(event.target as Node)) {
      // I think this can be removed? testing removing it for now.
      // It's causing issues with enabling scrolling when the cart is opened
      // closeAllSubMenus();
    }
  });

  // Sticky nav

  let lastScrollTop = 0;
  let isFixed = false;
  let isVisible = false;
  const promoBanner = document.querySelector('.js-promo-banner') as HTMLElement;
  let promoBannerHeight = promoBanner ? promoBanner.offsetHeight : 0;

  let placeholder: HTMLElement | null = null;

  const handleResize = () => {
    // Recalculate dimensions on resize
    promoBannerHeight = promoBanner ? promoBanner.offsetHeight : 0;

    // Reset fixed and visible states if necessary
    if (isFixed && !mobile) {
      header.classList.remove('fixed');
      if (placeholder) {
        placeholder.remove();
        placeholder = null;
      }
      isFixed = false;
    }

    if (window.matchMedia(`(min-width: ${navBp}px)`).matches && mobile) {
      closeMobileNav();
      // reset any sub menus that were opened
      closeAllSubMenus();

      mobile = false;
    } else if (!window.matchMedia(`(min-width: ${navBp}px)`).matches && !mobile) {
      closeAllSubMenus();

      mobile = true;
    }

    sizeDropdowns();

    // Optionally, force a scroll event to reapply the correct behavior
    handleScroll();
  };

  const handleScroll = () => {
    // grab current scroll postion
    const currentScrollTop = window.scrollY;
    // determine scrolling direction
    const scrollDirection: 'up' | 'down' =
      currentScrollTop > lastScrollTop ? 'down' : 'up';
    // Mobile-specific behavior
    if (mobile) {
      // Check if we've scrolled past the promo banner
      if (currentScrollTop > promoBannerHeight && !isFixed) {
        // Create a placeholder to avoid layout shift
        if (!placeholder) {
          placeholder = document.createElement('div');
          placeholder.style.height = `${header.offsetHeight}px`;
          header.parentNode!.insertBefore(placeholder, header);
        }
        header.classList.add('fixed');
        isFixed = true;
      }

      // Stop fixing the nav when scrolling back up to the promo banner's position
      if (currentScrollTop <= promoBannerHeight && isFixed) {
        // Remove the placeholder when no longer fixed
        if (placeholder) {
          placeholder.remove();
          placeholder = null;
        }
        header.classList.remove('fixed');
        isFixed = false;
      }
    } else {
      // Desktop-specific behavior

      if (placeholder) {
        placeholder.remove();
        placeholder = null;
      }

      // If dropdowns are open, we don't want to hide the nav
      if (!isDropdownOpen()) {
        // Check if we've scrolled past the nav and promo banner
        if (currentScrollTop > promoBannerHeight + header!.offsetHeight && !isFixed) {
          mainNav.classList.add('fixed');
          mainNav.classList.add('transition');
          isFixed = true;
        }

        // Check if we've scrolled back to the top, including promo banner height
        if (
          currentScrollTop <= promoBannerHeight + header!.offsetHeight &&
          isFixed
        ) {
          mainNav.classList.remove('fixed');
          isFixed = false;
        }
      }

      // As soon as we scroll down past the main nav, set the fixed nav to visible
      if (
        currentScrollTop > promoBannerHeight + header!.offsetHeight &&
        scrollDirection === 'down' &&
        !isVisible
      ) {
        mainNav.classList.add('visible');
        isVisible = true;
        // As soon as we reach one nav height below the nav, set the fixed nav to hidden
      } else if (
        currentScrollTop <=
          promoBannerHeight + header!.offsetHeight + mainNav.offsetHeight &&
        scrollDirection === 'up' &&
        isVisible
      ) {
        mainNav.classList.remove('visible');
        isVisible = false;
      }
    }

    // Update lastScrollTop for next scroll event
    lastScrollTop = currentScrollTop;
  };

  // Listen for scroll events
  let processing = false;
  window.addEventListener(
    'scroll',
    () => {
      if (!processing) {
        requestAnimationFrame(() => {
          handleScroll();
          processing = false;
        });
        processing = true;
      }
    },
    {
      passive: true,
    }
  );

  // Listen for resize events
  window.addEventListener('resize', handleResize);

  document.addEventListener('promoSliderReady', handleResize);
});
